export default __webpack_public_path__ + "static/media/MaskGroup280.40f266ba.png";